export default "__VITE_ASSET__B5BrGo3O__"